import {
  GET_PATIENTS,
  GET_PATIENTS_FAIL,
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_DETAILS,
  GET_PATIENTS_DETAILS_FAIL,
  GET_PATIENTS_DETAILS_SUCCESS,
  ADD_NEW_PATIENTS,
  ADD_PATIENTS_SUCCESS,
  ADD_PATIENTS_FAIL,
  UPDATE_PATIENTS,
  UPDATE_PATIENTS_SUCCESS,
  UPDATE_PATIENTS_FAIL,
  DELETE_PATIENTS,
  DELETE_PATIENTS_SUCCESS,
  DELETE_PATIENTS_FAIL,
  RESET_PATIENTS_STATE,
} from "./actionTypes";

export const getPatients = ({length, sort, page, IC, sort_by})=> ({
  type: GET_PATIENTS,
  payload: {length, sort, page, IC, sort_by},
});

export const getPatientsSuccess = patients => ({
  type: GET_PATIENTS_SUCCESS,
  payload: patients,
});

export const getPatientsFail = error => ({
  type: GET_PATIENTS_FAIL,
  payload: error,
});

export const getPatientsDetails = ({id}) => ({
  type: GET_PATIENTS_DETAILS,
  payload: {id},
});

export const getPatientsDetailsSuccess = patients => ({
  type: GET_PATIENTS_DETAILS_SUCCESS,
  payload: patients,
});

export const getPatientsDetailsFail = error => ({
  type: GET_PATIENTS_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewPatients = patients => ({
  type: ADD_NEW_PATIENTS,
  payload: patients,
});

export const addPatientsSuccess = patients => ({
  type: ADD_PATIENTS_SUCCESS,
  payload: patients,
});

export const addPatientsFail = error => ({
  type: ADD_PATIENTS_FAIL,
  payload: error,
});

//update 
export const updatePatients =({id, patients}) => ({
  type: UPDATE_PATIENTS,
  payload:{id, patients},
});

export const updatePatientsSuccess = patients => ({
  type: UPDATE_PATIENTS_SUCCESS,
  payload: patients,
});

export const updatePatientsFail = error => ({
  type: UPDATE_PATIENTS_FAIL,
  payload: error,
});

//delete 
export const deletePatients =({id}) => ({
  type: DELETE_PATIENTS,
  payload:{id},
});

export const deletePatientsSuccess = patients => ({
  type: DELETE_PATIENTS_SUCCESS,
  payload: patients,
});

export const deletePatientsFail = error => ({
  type: DELETE_PATIENTS_FAIL,
  payload: error,
});

//reset
export const resetPatientsState = () => {
  return {
      type: RESET_PATIENTS_STATE,
  }
}


